import React from 'react';
import Helmet from 'react-helmet';
import {useStaticQuery, graphql} from 'gatsby';

type SEOProps = {
  description?: string;
  lang?: string;
  meta?: Object[];
  title?: string;
};

const SEO: React.FC<SEOProps> = ({
  description,
  lang = 'de',
  meta = [],
  title,
}: SEOProps) => {
  const {site} = useStaticQuery(
      graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s`}
    >
      <link rel="shortcut icon" href="/business/favicon.ico" type="image/x-icon" />
      <link rel="icon" href="/business/favicon.ico" type="image/x-icon" />
      <link rel="icon" href="/business/favicons/icon-32x32.png" type="image/png" />
      <link rel="apple-touch-icon" sizes="48x48" href="/business/favicons/icon-48x48.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="/business/favicons/icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="96x96" href="/business/favicons/icon-96x96.png" />
      <link rel="apple-touch-icon" sizes="144x144" href="/business/favicons/icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="192x192" href="/business/favicons/icon-192x192.png" />
      <link rel="apple-touch-icon" sizes="256x256" href="/business/icons/icon-256x256.png" />
      <link rel="apple-touch-icon" sizes="384x384" href="/business/favicons/icon-384x384.png" />
      <link rel="apple-touch-icon" sizes="512x512" href="/business/favicons/icon-512x512.png" />

      <meta name="description" content={metaDescription} />
      <meta name="og:title" content={title} />
      <meta name="og:description" content={metaDescription} />
      <meta name="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata.author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
    </Helmet>
  );
};

export default SEO;
